import { createHelpers } from 'vuex-map-fields';

const { getUserField, updateUserField } = createHelpers({
	getterType: `getUserField`,
	mutationType: `updateUserField`,
});


const state = {
	module : {
		is_load : false,
	},
	user : {
		id : 0,
		guest : 1,
		is_auth: false,
	}
};


const getters = {

	getUser(state) {
		return state.user;
	},

	getUserModule(state) {
		return state.module;
	},

	getUserField,

};
// actions
const actions = {

	LOAD_USER({commit}) {
		api.get('/user/me').then(({data}) => {
			if(data.status === "operation_success") {
				state.user = {...state.user,...data.data};
				EventBus.$emit('user_added', state.user);
			}
		})
	},

};


// mutations
const mutations = {
	updateUserField,

	addUser(state,data) {
		state.user = data;
		EventBus.$emit('user_added', data);
		state.module.is_load = true;
	},

	setUserField(state,data) {
		state.user = {...state.user,...data};
	},
};


export default {
	namespaced: true,
	state,
	actions,
	getters,
	mutations,
}
